<template>
  <mtd-header ref="headerRef" class="mc-header" :style="styleObj">
    <div v-if="showTag" class="env-tag-container">
      <span class="mc-env-tag">{{ activeEnv }}</span>
    </div>
    <div class="mc-header-left-container">
      <slot name="left"></slot>
    </div>
    <div class="mc-header-right-container">
      <env-select :active-env="activeEnv" />
      <slot name="right"></slot>
    </div>
  </mtd-header>
</template>

<script>
/**
 * MCHeader 组件，页首组件
 *
 * @props {string} systemType 系统类型，必填
 * @props {Object} backgroundColor 各环境的背景颜色，支持英文代码、十六进制、RGB
 */
import { Header as MtdHeader } from "@ss/mtd-vue";
import EnvSelect from "./components/EnvSelect.vue";
import { EnvNames } from "./interface";

const getActiveEnv = () => {
  const NODE_ENV = process.env.NODE_ENV;
  return NODE_ENV || EnvNames.Production;
};

const shouldShowTag = (activeEnv) => {
  return [EnvNames.Test, EnvNames.Staging].includes(activeEnv);
};

const getStyleObj = (activeEnv, backgroundColor) => {
  const colorIndex =
    activeEnv === EnvNames.Development ? EnvNames.Test : activeEnv;
  return {
    "--background-color": backgroundColor[colorIndex],
  };
};

export default {
  name: "MCHeader",
  components: {
    MtdHeader,
    EnvSelect,
  },
  provide() {
    return {
      systemType: this.systemType,
    };
  },
  props: {
    systemType: {
      required: true,
      type: String,
    },
    backgroundColor: {
      type: Object,
      default() {
        return {
          test: "white",
          staging: "#FFFFFF",
          production: "rgb(255,255,255)",
        };
      },
    },
  },
  data() {
    return {
      activeEnv: getActiveEnv(),
    };
  },
  computed: {
    showTag() {
      return shouldShowTag(this.activeEnv);
    },
    styleObj() {
      return getStyleObj(this.activeEnv, this.backgroundColor);
    },
  },
};
</script>

<style lang="scss" scoped>
.env-tag-container {
  position: absolute;
  width: 100%;
  height: 25px;
  text-align: left;
  top: 0;
  left: 0;
}

.mc-header {
  width: 100%;
  background-color: var(--background-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mc-header-right-container {
  display: flex;
  align-items: center;
}

.mc-env-tag-container {
  position: absolute;
  width: 100%;
  height: 25px;
  text-align: left;
  top: 0;
  left: 0;
  border-top: 4px solid #fed030;
}

.mc-env-tag {
  display: inline-block;
  position: absolute;
  top: 0px;
  background: #fed030;
  padding: 0 2px 2px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  line-height: 10px;
  color: #121924;
  font-weight: 600;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  width: 62px;
  text-align: center;
  text-transform: capitalize;
}

:root[dir="rtl"] .mc-env-tag {
  right: 0px;
}

.mc-env-button {
  margin-right: 32px;
}

.mc-env-label {
  padding-left: 2px;
}

.mc-st-env {
  background: #8e3deb;
  color: #fff;
}

.mc-test-env {
  background: #fed030;
  color: #000;
}

.mc-env-en {
  padding: 0 2px;
  background: rgba(83, 86, 103, 0.74);
  color: #fff;
}

.mtd-dropdown-menu-item .swimlane-item {
  display: flex;
  align-items: center;
}

.swimlane-item .swimlane-btn {
  line-height: 32px;
}
</style>
